function value(event) {
  return event.target.value
}

export default value
